<template>
    <div>
      <v-parallax src="https://smitha-cdn.s3.us-east-2.amazonaws.com/Content/images/md/bg-030.jpg" style="height: 250px">
        <v-container
          fluid
          >
          <v-row>
            <v-col class="text-center">
              <h1 class="subtitle-1 text-uppercase">
                Hi there
              </h1>
              <span class="text-lg-h1 text-h2">
                Blog
              </span>
              <p class="subtitle-2">
                Let me tell you a little about myself
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-parallax>
      <v-container class="py-7">
        <h3 class="subtitle-1 text-uppercase">
            About me
        </h3>
        <span class="text-h4">
            My life
        </span>
        <p class="subtitle-2">
            Back in my day
        </p>
        <p class="text-body-1">
            Here's my main deal.
        </p>
        <p class="text-body-2">
            Here's some of my other deals.
        </p>
        <p class="text-body-2">
            Here's some of my other deals.
        </p>
        <p class="text-body-2">
            Here's some of my other deals.
        </p>
      </v-container>
    </div>
</template>

<script>
export default {
  
}
</script>
